/**
 * Scrolling utility functions for consistent scroll behavior across components
 */

/**
 * Smoothly scrolls to a target element with customizable offset
 * @param {HTMLElement|null} targetElement - The element to scroll to
 * @param {Object} options - Configuration options
 * @param {number} options.mobileOffset - Offset for mobile viewports (default: 140)
 * @param {number} options.desktopOffset - Offset for desktop viewports (default: 200)
 * @param {number} options.breakpoint - Breakpoint to switch between mobile/desktop (default: 575)
 */
export const scrollToElement = (targetElement, options = {}) => {
    const {
        mobileOffset = 140,
        desktopOffset = 200,
        breakpoint = 575
    } = options;

    if (!targetElement) {
        console.warn('scrollToElement: No target element provided');
        return;
    }

    const elementRect = targetElement.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const offset = window.innerWidth < breakpoint ? mobileOffset : desktopOffset;
    
    window.scrollTo({
        top: absoluteElementTop - offset,
        behavior: 'smooth'
    });
};

/**
 * Scrolls to an element by its ID or class selector
 * @param {string} selector - CSS selector for the target element
 * @param {Object} options - Configuration options (same as scrollToElement)
 */
export const scrollToSelector = (selector, options = {}) => {
    const targetElement = document.querySelector(selector);
    scrollToElement(targetElement, options);
};

/**
 * Scrolls to the ProductsNav element (ProductNav component)
 * Uses the same offset configuration as the original scrollToSpecials function
 */
export const scrollToProductsNav = () => {
    // Target the ProductNav component by its specific class
    const productNavElement = document.querySelector('.headless-products-nav');
    
    if (!productNavElement) {
        // Fallback to the products container if ProductNav isn't found
        const productsContainer = document.querySelector('.headless-products-container');
        scrollToElement(productsContainer);
        return;
    }
    
    scrollToElement(productNavElement);
};

/**
 * Legacy compatibility function - matches the original scrollToSpecials behavior exactly
 * @param {React.RefObject} specialsContainerRef - Ref to the specials container
 */
export const scrollToSpecials = (specialsContainerRef) => {
    if (specialsContainerRef?.current) {
        scrollToElement(specialsContainerRef.current);
    }
};